import { StyledModal, Button, Content } from './styles'
import { RequiredModalProps } from './types'

const RequiredModal = ({ isModalOpen, onClose, requiredType }: RequiredModalProps) => {
  const modalContent = {
    title: 'กรุณาระบุจำนวนเงินรายการค่ารักษาพยาบาล',
    content: 'ต้องระบุอย่างน้อย 1 รายการ',
    cancelText: 'ปิด',
  }

  if (requiredType === 'documents') {
    modalContent.title = 'กรุณาแนบไฟล์เอกสารให้ครบถ้วน'
    modalContent.content = ''
  }

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      width={400}
      centered
      onCancel={onClose}
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {modalContent.cancelText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
    </StyledModal>
  )
}

export default RequiredModal
